import { render, staticRenderFns } from "./otherConsultation.vue?vue&type=template&id=0ca4c7ce&"
import script from "./otherConsultation.vue?vue&type=script&lang=js&"
export * from "./otherConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports